// Modules
import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import ModalAction from "../../components/8 - ModalAction";
import Carousel from "../../components/1 - Carousel";
import Resume from "../../components/2 - Resume";
import CoProperty from "../../components/3 - CoProperty";
import HomeImprovments from "../../components/4 - HomeImprovments";
import NeighborhoodAnalyse from "../../components/5 - NeighborhoodAnalyse";
import BalanceSheet from "../../components/6 - BalanceSheet";
import Divider from "../../components/utils/Divider";
import LogoLink from "../../components/utils/LogoLink";
import config from "../../config";

// Assets
import "./home.scss";

const Home = (props) => {
  const {
    data,
    idFiche,
    loading,
    proposeur,
  } = props;
  const {
    liste_pieces,
    balcon,
    terrasse,
    type_bien,
    est_termine,
    ville,
    quartier,
  } = data;
  const listHomeImprovmentsImages = config.galleryHomeImprovments;
  const listNeighborhoodImages = config.galleryNeighborhood;
  const { isMobile, isTablet } = useContext(ApiContext);
  const [rooms, setRooms] = useState([]);
  const [imagesArr, setImagesArr] = useState([]);
  const [showActionModal, setShowActionModal] = useState(true);

  /**
   * Function that allows you to find the right image for the flip-back, 
   * on the CONSTRUCTION_IMAGES object, it sorts first by room, then by city, 
   * and finally by type to return the right image
   * @returns {String} : link of room after lifting
   */
   const handleChangeImageToFlip = (roomName) => {
    let numberRoom = 0;
    let image = null;

    // Sorts by room, comparing it with the roomName if it is the same room, 
    // and retrieves the number of the room to choose the image with the index of the corresponding 
    // array
    Object.keys(listHomeImprovmentsImages).map((room) => {
      if (roomName.toLowerCase().includes("chambre"))
        numberRoom = Number(roomName.slice(-1));

      if (room.replaceAll("_", " ").includes(roomName.toLowerCase())
        || roomName.toLowerCase().includes(room.replaceAll("_", " "))
        || room.replaceAll("_", " ") === roomName.toLowerCase()) {

        // Finnaly, Sorts by type, comparing it with type Good if it is the same type.
        // Then this takes the whole path and fetch the final link, 
        // taking care to check if it's an array or not, and if so, 
        // return the correct index with the numberRoom previously fetched.
        Object.keys(listHomeImprovmentsImages[room]).map((type) => {
          if (type_bien.toLowerCase().includes(type.toLowerCase())) {
            image = listHomeImprovmentsImages[room][type];

            if (typeof image === "object")
              image = listHomeImprovmentsImages[room][type][numberRoom];
          }
          return image;
        });
        // REMOVE THIS CODE FOR V2 BECAUSE BELOW IS THE COMPLETE CODE

        // FOR V2
        // Then sort by city, comparing it with the cityName if it is the same city
        // Object.keys(listHomeImprovmentsImages[room]).map((city) => {
        //   if (cityName.toLowerCase().includes(city.toLowerCase())) {

        // Finnaly, Sorts by type, comparing it with type Good if it is the same type.
        // Then this takes the whole path and fetch the final link, 
        // taking care to check if it's an array or not, and if so, 
        // return the correct index with the numberRoom previously fetched.
        // Object.keys(listHomeImprovmentsImages[room]).map((type) => {
        //   if (typeBien.toLowerCase().includes(type.toLowerCase())) {
        //     image = listHomeImprovmentsImages[room][type];

        //     if (typeof image === "object")
        //       image = listHomeImprovmentsImages[room][type][numberRoom];
        //   }
        //   return image;
        // });
        //   }
        //   return image;
        // });
      }
      return image;
    });
    return image;
  };

  /**
   * Parse the array that is listing all the rooms by adding missing
   * properties such as if there's a balcony or a terrace, and the
   * backImg reference.
   * Triggered at reception of the API datas.
   */
   useEffect(() => {
    if (!liste_pieces)
      return;

    let parsedListePieces = [ ...liste_pieces ];

    parsedListePieces = parsedListePieces.map((room) => {
      if (est_termine === false || est_termine === undefined)
        return {
          ...room,
          imgBack: handleChangeImageToFlip(room.label),
        };
      return { ...room };
    });

    if (balcon === false && terrasse === false)
      setRooms(parsedListePieces);
    else {
      if (balcon === true)
        parsedListePieces.push({
          label: "Balcon",
          descr: null,
          img: null,
          imgBack: null,
        });
      else if (terrasse === true)
        parsedListePieces.push({
          label: "Terrasse",
          descr: null,
          img: null,
          imgBack: null,
        });
      setRooms(parsedListePieces);
    }
  }, [liste_pieces, balcon, terrasse]); // eslint-disable-line

  /**
   * Sets the images to display for the neighborhood section and the carousel.
   * Triggered on reception of 'ville' and 'quartier' coming from the API, and 'listHomeImprovmentsImages'.
   */
  useEffect(() => {
    if (ville === undefined || quartier === undefined)
      return;

    const parsedVille = ville.replace(" ", "_");
    let newImagesArr = [];

    if (listNeighborhoodImages[parsedVille] === undefined)
      return;

    listNeighborhoodImages[parsedVille].map((neighborhood) => {
      if (neighborhood.label === quartier)
        newImagesArr = neighborhood.images;
      return null;
    });

    if (newImagesArr.length > 0)
      setImagesArr(newImagesArr);
    // If the current neighborhood doesn't have a reference in the json file with images, put default instead
    else {
      const index = listNeighborhoodImages[parsedVille].findIndex((value) => value.label === "default");

      setImagesArr(listNeighborhoodImages[parsedVille][index].images);
    }
  }, [ville, quartier, listNeighborhoodImages]);

  return (
    <div className={`home-container ${isMobile === true || isTablet === true ? "mobile" : ""} ${showActionModal === false ? "reduced" : ""}`}>
      <ModalAction
        idFiche={idFiche}
        loader={loading}
        data={data ?? {}}
        showCTA={showActionModal}
        setShowCTA={setShowActionModal}
        proposeur={proposeur}
      />
      <div id="carousel">
        <Carousel
          loader={loading}
          data={data ?? {}}
          idFiche={idFiche}
          rooms={rooms}
          imagesNeighborhoodArr={imagesArr}
        />
      </div>
      <div id="details-of-rent">
        <Resume
          data={data ?? {}}
          loader={loading}
        />
      </div>
      <div id="co-property">
        <CoProperty
          data={data ?? {}}
          loader={loading}
        />
      </div>
      <div id="home-improvments">
        <HomeImprovments
          data={data ?? {}}
          loader={loading}
          rooms={rooms}
        />
      </div>
      <div id="neighborhood">
        <NeighborhoodAnalyse
          data={data ?? {}}
          loader={loading}
          imagesArr={imagesArr}
        />
      </div>
      <div id="balance-sheet">
        <BalanceSheet
          idFiche={idFiche}
          data={data ?? {}}
          loader={loading}
        />
      </div>
      <Divider
        text="Investissement validé par"
        img={<LogoLink clssName="logo" type="primary" />}
        loader={loading}
        clssName="bevouac-approuval"
        centered={true}
      />
    </div>
  );
};

Home.propTypes = {
  data: PropTypes.object.isRequired,
  idFiche: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  proposeur: PropTypes.string.isRequired,
};

export default Home;
